import { location } from 'cdui-js';
import { DiFiNavBar } from '../../components/DiFi/DiFiNavBar';
import { goBackByBrowser } from '../../lib/browser';
import { getLegalDoc } from './content';
import { isLegalEmbeddedInApp } from './legalEmbed';
import { getLegalDocKeyFromPath } from './routes';
import { NotFound } from '../NotFound';
import { getLang } from '../../i18n';

export const LegalDocumentPage = () => {
  const docKey = getLegalDocKeyFromPath(location.path);
  const embedded = isLegalEmbeddedInApp();

  if (!docKey) {
    return <NotFound />;
  }

  const doc = getLegalDoc(docKey, getLang());
  if (!doc) {
    return <NotFound />;
  }

  const pageClass = embedded
    ? 'legal-document-page page-wrapper-no-header flex-column bg-c-D'
    : 'legal-document-page page-wrapper-with-header flex-column bg-c-D';

  return (
    <div class={pageClass}>
      {embedded ? null : (
        <DiFiNavBar title={doc.navTitle} fixed class="bg-c" onClickLeft={() => goBackByBrowser()} />
      )}

      <div
        class="flex-1 no-scrollbar padding-x padding-b-L"
        style={{ 'overflow-y': 'auto', 'padding-top': embedded ? '16px' : '54px' }}
      >
        <div class="font-s-L color-D font-bold margin-b-XS" style={{ 'line-height': '26px' }}>
          {doc.title}
        </div>

        {doc.intro ? (
          <div class="font-s-S color margin-b-L" style={{ 'line-height': '22px', 'white-space': 'pre-wrap' }}>
            {doc.intro}
          </div>
        ) : null}

        {doc.sections.map((section) => (
          <div class="margin-b-L">
            {section.title ? (
              <div class="font-s-S color-D font-bold margin-b-XS" style={{ 'line-height': '22px' }}>
                {section.title}
              </div>
            ) : null}
            {section.paragraphs.map((paragraph) => (
              <div
                class="font-s-S color margin-b-XS"
                style={{ 'line-height': '22px', 'white-space': 'pre-wrap' }}
              >
                {paragraph}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LegalDocumentPage;
